const genderOptions = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Feminino" },
  { value: "", label: "Prefiro não informar" },
];

export default genderOptions;
